<template>
    <div class="container-fluid bg--confirmation px-0" :style="{ backgroundImage: `url(${backgroundImage})` }">
        <div class="bg--confirmation__shadow h-100 position-relative">
            <img src="../../assets/images/landing/details-section/detail4.png"
                class="detail4 position-absolute d-none d-lg-flex" v-if="branding.logoImgUrl"/>
            <img src="../../assets/images/landing/details-section/detail2.png"
                class="detail3 position-absolute d-none d-lg-flex" v-if="branding.logoImgUrl"/>
            <img src="../../assets/images/landing/details-section/detail1.png" alt="" class="detail1 position-absolute" v-if="branding.logoImgUrl">
            <img src="../../assets/images/landing/details-section/detail2.png" alt="" class="detail2 position-absolute" v-if="branding.logoImgUrl">
            <div class="container px-2">
                <div class="row justify-content-center">
                    <div class="col-12 text-center py-3 position-relative">
                        <img src="../../assets/images/logo.png" alt="">
                    </div>
                    <div class="col col-xl-5 col-lg-6 col-md-8 px-4">
                        <div class="container bg-white rounded-1 p-3 d-grid pb-1">
                            <h2 :style="branding.titles">You’re All Set!</h2>
                            <span class="text__description mb-3" >
                                5 Days & 4 Nights at a Luxury {{ destination }}
                                Resort
                            </span>
                            <span class="text__price mb-2" :style="branding.titles">${{ getCopy.priceUSD }}<sup class="text__price--currency">USD</sup></span>
                            <h2 :style="branding.titles">For 2 adults </h2>
                            <table class="table lh-base mb-0">
                                <tbody>
                                    <tr class="border-top">
                                        <th scope="row">Destination:</th>
                                        <td>{{ destination }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Resort:</th>
                                        <td>Luxury Mexico Resort</td>

                                    </tr>
                                    <tr>
                                        <th scope="row">Days & Nights:</th>
                                        <td>5 Days & 4 Nights</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Room Type:</th>
                                        <td>Deluxe Suite or Studio Suite</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Total Paid:</th>
                                        <td>
                                            <span class="text-decoration-line-through">${{ getCopy.retailPriceUSD }}</span> <span
                                                class="fw-bold">${{ getCopy.priceUSD }}</span> for 2 adults
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4" class="border-bottom-0 text__terms">
                                            <span class="fw-bold">Terms:</span> Our Resort All-Inclusive program covers,
                                            unlimited meals, unlimited
                                            beverages, daily activities, nightly entertainment themed shows.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 px-4 pb-5 mb-5 mb-lg-0 pb-lg-0">
                        <div class="container-fluid  rounded-1 p-3 pb-0 mb-5 mb-lg-0">
                            <div class="row d-flex justify-content-center pb-3">
                                <div class="col col-lg-4 col-md-8 d-flex justify-content-center">
                                    <img src="../../assets/images/agent-pic.png" alt="" class="rounded-circle"
                                        width="70">
                                    <p class="m-0 p-0 text__agent d-flex align-items-center ps-3">
                                        A vacation concierge
                                        will be in touch with you soon to book your dates and give you all the details!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-xl-5 col-lg-6 px-4">
                        <div class="col terms__footer rounded-2 p-3 pt-lg-2 px-3 fixed-bottom ">
                            <span class="subtext_footer">Call now to save your dates</span>
                            <a class="col btn-next p-3 py-lg-2 mt-2 text-decoration-none" :style="branding.buttons" :href="`tel:${getPhoneNumber}`" @click.prevent="callNow">
                                <span class="fw-bold">Call Now! {{ getPhoneNumber }}</span> <img
                                    src="../../assets/icons/phone.svg" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from '@/store/landing';

export default {
    name: "Confirmation",
    setup() {
        return {
            websiteStore: useStore()
        }
    },
    data() {
        return {
            destination: null,
            destinationBackgrounds: {
                "Riviera Cancun": require("@/assets/images/landing/backgrounds/bg-confirmation.jpg"),
                "Los Cabos": require("@/assets/images/landing/backgrounds/bg-cabo.jpg"),
                "Puerto Vallarta": require("@/assets/images/landing/backgrounds/bg-vallarta.jpg"),
                Default: require("@/assets/images/landing/backgrounds/bg-confirmation.jpg")
            }
        }
    },
    computed: {
        backgroundImage() {
            // Normalize capitalization (in case query comes in lowercase)
            const dest = this.destination?.trim().toLowerCase()
            const key = Object.keys(this.destinationBackgrounds).find(k => k.toLowerCase() === dest)
            return this.destinationBackgrounds[key] || this.destinationBackgrounds.Default
        },
        getPhoneNumber() {
            const source = this.websiteStore.utmSourceInitial;
            return source == 'google' ? '8337142114' : '8882730235';
        },
        branding() {
            return this.websiteStore.getCampaignBranding(this.$route.query.utm_campaign);
        },
        destinationSlug() {
            // /confirmation has no :destinationSlug route param — only ?destination=<name> (e.g. "Los Cabos")
            const match = this.websiteStore.destinations.find(d => d.name === this.destination);
            return match ? match.slug : null;
        },
         getCopy() {
      return this.websiteStore.getCampaignCopy(this.$route.query.utm_campaign, this.destinationSlug);
    }
    },
    mounted() {
        this.destination = this.$route.query.destination || 'Cancun'
        const dataLayerName = 'myCustomDataLayer';
        const tagId = 'AW-302071804';
        const scriptId = `gtag-script-${tagId}`;


        // Crea el dataLayer si no existe
        if (!window[dataLayerName]) {
            window[dataLayerName] = [];
        }

        // Si ya existe el script y gtag está definido, solo dispara evento
        if (window.gtag) {
            this.initGtagAndSendEvent();
            return;
        }

        // Si no, crea script y espera a que cargue
        let script = document.getElementById(scriptId);

        if (!script) {
            script = document.createElement('script');
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}&l=${dataLayerName}`;
            script.id = scriptId;
            document.head.appendChild(script);
        }

        script.onload = () => {
            this.initGtagAndSendEvent();
        };
    },
    methods: {
        initGtagAndSendEvent() {
            const dataLayerName = 'myCustomDataLayer';
            const tagId = 'AW-302071804';

            window.gtag = function () {
                window[dataLayerName].push(arguments);
            };

            if (!window.__gtagInitialized) {
                window.gtag('js', new Date());
                window.gtag('config', tagId, {
                    'data_layer_name': dataLayerName
                });
                window.__gtagInitialized = true;
            }

            // Aquí dispara el evento custom
            window.gtag('event', 'landing page cancun form sent');
        },
        callNow() {
            // Intenta abrir tel: y registra evento
            const num = this.getPhoneNumber;
            window.location.href = `tel:+52${num}`;
            if (window.gtag) {
                window.gtag('event', 'click_call_now', { phone: num });
            }
        }
    }
};
</script>

<style scoped>
.btn-next {
    background: linear-gradient(91deg, #FAA408 0%, #FF221E 100%);
}

.detail1 {
    max-width: 200px;
    top: -60px;
    left: -120px;

}

.detail2 {
    max-width: 64px;
    top: 3px;
    right: 0px;

}

.bg--confirmation {

    height: 100vh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.bg--confirmation__shadow {
    background-color: rgba(0, 0, 0, .15) !important;
}

.table {
    font-size: 14px !important;
}

th {
    font-weight: bold;
    color: #525252;
}

h2 {
    font-weight: bold;
    color: #FF1F1F;
}

.text__description {
    font-size: 14px;
}

.text__price {
    color: #FF1F1F;
    font-family: Poppins;
    font-size: 64px;
    font-style: normal;
    font-weight: 800;
    line-height: 74px;
    /* 115.625% */
}

.text__price--currency {
    font-weight: 800;
}

.text__terms {
    font-size: 12px;
}

.text__agent {
    font-size: 12px;
    font-weight: 600;
    color: #ffff;
}

.terms__footer {
    background-color: #EFEFEF;
    border-bottom-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}

sup {
    top: -1.5rem !important;
    font-size: 32px;
}

@media (min-width: 992px) {
    .subtext_footer {
        font-size: 12px;
        font-weight: 600;
    }

    .terms__footer {
        background-color: #EFEFEF;
        position: initial;
        border-bottom-right-radius: 0.375rem !important;
        border-bottom-left-radius: 0.375rem !important;
    }

    .detail1 {
        max-width: 450px;
        top: -160px;
        left: -230px;
    }

    .detail2 {
        max-width: 134px;
        top: 3px;
        right: 0px;
    }

    .detail3 {
        max-width: 124px;
        bottom: 10px;
        transform: rotate(190deg);
        left: -10px;
    }

    .detail4 {
        max-width: 338px;
        bottom: 0px;
        right: 0px;
    }

}
</style>